"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePeerMonthlyLoading = exports.usePeerMonthly = exports.usePeerDailyLoading = exports.usePeerDaily = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var _peers = require("../reducers/peers");

var usePeerMonthly = function usePeerMonthly(prospectId, startDate, endDate, baseUrl, authToken) {
  var internalUsage = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var dispatch = (0, _reactRedux.useDispatch)();
  var peer = (0, _reactRedux.useSelector)((0, _peers.getPeerMonthly)(prospectId, startDate, endDate));
  (0, _react.useEffect)(function () {
    if (prospectId && authToken && baseUrl && internalUsage) {
      dispatch((0, _peers.fetchPeerMonthlyIfNeeded)(prospectId, startDate, endDate, baseUrl, authToken));
    }
  }, [prospectId, startDate, endDate, internalUsage]);
  return peer;
};

exports.usePeerMonthly = usePeerMonthly;

var usePeerMonthlyLoading = function usePeerMonthlyLoading() {
  var loading = (0, _reactRedux.useSelector)(_peers.peerMonthlyLoading);
  return loading;
};

exports.usePeerMonthlyLoading = usePeerMonthlyLoading;

var usePeerDaily = function usePeerDaily(prospectId, startDate, endDate, baseUrl, authToken) {
  var internalUsage = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var dispatch = (0, _reactRedux.useDispatch)();
  var peer = (0, _reactRedux.useSelector)((0, _peers.getPeerDaily)(prospectId, startDate, endDate));
  (0, _react.useEffect)(function () {
    if (prospectId && authToken && baseUrl && internalUsage) {
      dispatch((0, _peers.fetchPeerDailyIfNeeded)(prospectId, startDate, endDate, baseUrl, authToken));
    }
  }, [prospectId, startDate, endDate, internalUsage]);
  return peer;
};

exports.usePeerDaily = usePeerDaily;

var usePeerDailyLoading = function usePeerDailyLoading() {
  var loading = (0, _reactRedux.useSelector)(_peers.peerDailyLoading);
  return loading;
};

exports.usePeerDailyLoading = usePeerDailyLoading;